
import React from 'react';

const BedUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#2d2d2d"
				d="M26 14h-2v-1c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v1h-2v-1c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v1H7V9c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v4h2V9c0-1.65-1.35-3-3-3H8C6.35 6 5 7.35 5 9v5.18C3.84 14.6 3 15.7 3 17v9h2v-2h22v2h2v-9c0-1.65-1.35-3-3-3zm-7-1h3v1h-3v-1zm-9 0h3v1h-3v-1zm-4 3h20c.55 0 1 .45 1 1v1H5v-1c0-.55.45-1 1-1zm-1 6v-2h22v2H5zM28 30H4v2h24v-2z"
			></path>
		</svg>
	);
};

export default BedUnderline;
